import "./style.css";
import { jsx as t } from "react/jsx-runtime";
import s from "../../containers/FormattedText/FormattedText.js";
const c = "_tagBox_1arw7_1", n = "_label_1arw7_10", a = {
  tagBox: c,
  label: n
};
function x({ bgColor: o, color: l, name: r, ...e }) {
  return /* @__PURE__ */ t("div", { ...e, className: a.tagBox, style: { backgroundColor: o, color: l }, children: /* @__PURE__ */ t(s, { className: a.label, children: r }) });
}
export {
  x as default
};
//# sourceMappingURL=ProductTag.js.map
